import { WSForm, WSInputText } from "@wingspanhq/fe-component-library";
import { AccountProfileCompanyLinks } from "@wingspanhq/wingspan-api-sdk";
import React from "react";
import * as Yup from "yup";
import { queriesAccounts } from "@query";
import { useSession } from "@hooks/useSession";
import { validatorWebsite } from "../../../../../shared/validators/validatorWebsite";
import { LayoutFormEdit } from "./LayoutFormEdit";

type FormData = { newValue: string };

type Props = {
  onClose: () => void;
  name: keyof AccountProfileCompanyLinks;
  label: string;
};

export const FormEditLink: React.FC<Props> = props => {
  const session = useSession();
  const queryAccount = queriesAccounts.getAccount.useQuery({
    accountId: session.accountId
  });

  const [mutate, meta] = queriesAccounts.updateAccount.useMutation({
    dependencies: [queriesAccounts.getAccount.queryKeyBase],
    onSuccess: props.onClose
  });

  const initialValue = queryAccount.data?.profile?.company?.links?.[props.name];

  const onSubmit = (data: FormData) =>
    mutate({
      accountId: session.accountId,
      accountUpdate: {
        profile: {
          company: {
            links: {
              [props.name]: data.newValue
            }
          }
        }
      }
    });

  return (
    <WSForm<FormData>
      onSubmit={onSubmit}
      defaultValues={{
        newValue: initialValue || ""
      }}
      validationSchema={Yup.object({
        website: validatorWebsite
      })}
    >
      <LayoutFormEdit
        isLoading={meta.isLoading}
        error={meta.error}
        onCancel={props.onClose}
      >
        <WSForm.Field
          name="newValue"
          label={`${props.label} (optional)`}
          component={WSInputText}
          componentProps={{
            placeholder: "http://"
          }}
        />
      </LayoutFormEdit>
    </WSForm>
  );
};
